export default __webpack_public_path__ + "/amazing-plan-by-kevin-macleod-from-filmmusic-io.mp3";